import React, { FC } from 'react'

import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import { TServiceCard } from '../types/ServiceCard.types'
import { ServiceCardContainer } from '../styles/ServiceCard.styles'

export const ServiceCardView: FC<TServiceCard> = ({
  content: { confirmButton, details, title },
  onClick,
}) => (
  <ServiceCardContainer>
    <Text variant="headline-h3" color="typography" colorWeight={600} as="p" semiBold>
      {title}
    </Text>
    <Text variant="body-3" color="typography" colorWeight={400} as="p">
      {details}
    </Text>
    <Button size="small" variant="secondary" onClick={onClick}>
      {confirmButton}
    </Button>
  </ServiceCardContainer>
)
